var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _path5, _path6, _path7, _rect4, _rect5, _rect6, _path8, _path9, _path10, _path11, _rect7, _rect8, _circle, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapitalOneLandingImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 720,
    opacity: 0,
    width: 720
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.55,659.82a32.32,32.32,0,0,1-32.32-32.32V570.56l-44.91-44.62c-19.73-19.6,8.06-47.57,27.79-28l-28.46-28.28c-19.73-19.6,8.06-47.57,27.79-28l-12.68-12.6c-19.73-19.6,8.06-47.58,27.8-28L469,416.51c-18.94-18.82,5.91-45.34,25.38-30.09h.27L616.05,507a64.56,64.56,0,0,1,19.08,45.82V691H488.55Z",
    fill: "#bc9275"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M488.55,659.82h79.64l3.46-15,18.55-86.91a33.11,33.11,0,0,0-7-28.2L469.09,416.58l-15.53-15.43c-19.74-19.61-47.53,8.37-27.8,28l12.68,12.6c-19.73-19.6-47.52,8.37-27.79,28L439.11,498c-19.73-19.6-47.52,8.37-27.79,28l44.91,44.62V627.5A32.32,32.32,0,0,0,488.55,659.82Z",
    fill: "#9b745a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.75,659.82a32.32,32.32,0,0,0,32.32-32.32V570.56L308,525.94c19.73-19.6-8.06-47.57-27.79-28l28.46-28.28c19.73-19.6-8.06-47.57-27.79-28l12.68-12.6c19.73-19.6-8.06-47.58-27.79-28l-15.47,15.36c19-18.82-5.9-45.34-25.38-30.09h-.27L103.26,507a64.52,64.52,0,0,0-19.09,45.82V691H230.76Z",
    fill: "#bc9275"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.07,627.5V570.56L308,525.94c19.73-19.6-8.06-47.57-27.79-28l28.46-28.28c19.73-19.6-8.06-47.57-27.79-28l12.68-12.6c19.73-19.6-8.06-47.58-27.79-28l-15.54,15.43L136.13,529.71a33.08,33.08,0,0,0-7,28.2l18.55,86.91,3.47,15h79.63A32.32,32.32,0,0,0,263.07,627.5Z",
    fill: "#9b745a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#013d5b",
    height: 519.55,
    rx: 13.13,
    width: 376.97,
    x: 172.41,
    y: 111.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 413.23,
    width: 312.64,
    x: 204.57,
    y: 143.88
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381.49,593.81a20.6,20.6,0,1,1-20.6-20.6A20.6,20.6,0,0,1,381.49,593.81Z",
    fill: "#598aaa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490.24,491.51a6.55,6.55,0,0,1,9.87-1.63l75,65.87q1.3,1.13,2.49,2.34a4.67,4.67,0,0,0,.81.66A23.68,23.68,0,0,1,589.3,577l5.11,68.86s-11.35,32.48-19.87,32.48a51.35,51.35,0,0,1-34.16-89.71L499.94,552.5a6.1,6.1,0,0,1-.59-.55C475.26,525.9,483.86,502.32,490.24,491.51Z",
    fill: "#bc9275"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M229.06,491.51a6.55,6.55,0,0,0-9.87-1.63l-75,65.87c-.88.75-1.7,1.53-2.49,2.34a4.74,4.74,0,0,1-.82.66A23.67,23.67,0,0,0,130,577l-5.11,68.86s11.35,32.48,19.87,32.48a51.35,51.35,0,0,0,34.15-89.71l40.44-36.08A5.12,5.12,0,0,0,220,552C244,525.9,235.45,502.32,229.06,491.51Z",
    fill: "#bc9275"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00c0e5",
    height: 138.08,
    rx: 8.26,
    width: 207.12,
    x: 257.96,
    y: 359.07
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00a3c4",
    height: 75.14,
    rx: 2.57,
    transform: "translate(-158.03 789.08) rotate(-90)",
    width: 7.19,
    x: 311.93,
    y: 435.99
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00a3c4",
    height: 85.14,
    rx: 2.57,
    transform: "translate(-71.05 876.06) rotate(-90)",
    width: 7.19,
    x: 398.91,
    y: 430.99
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.2,408.91h13.57a0,0,0,0,1,0,0V423a0,0,0,0,1,0,0H284a5.83,5.83,0,0,1-5.83-5.83v-8.23A0,0,0,0,1,278.2,408.91Z",
    fill: "#fff1d0",
    transform: "translate(700.92 130.96) rotate(90)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278,425.26H292a0,0,0,0,1,0,0v13.45a0,0,0,0,1,0,0h-8.23a5.83,5.83,0,0,1-5.83-5.83v-7.63A0,0,0,0,1,278,425.26Z",
    fill: "#fff1d0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.67,424.9h13.57a0,0,0,0,1,0,0V439a0,0,0,0,1,0,0h-7.75a5.83,5.83,0,0,1-5.83-5.83V424.9A0,0,0,0,1,305.67,424.9Z",
    fill: "#fff1d0",
    transform: "translate(-119.47 744.38) rotate(-90)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M305.43,409.15h14.06a0,0,0,0,1,0,0v13.45a0,0,0,0,1,0,0h-8.23a5.83,5.83,0,0,1-5.83-5.83v-7.63A0,0,0,0,1,305.43,409.15Z",
    fill: "#fff1d0",
    transform: "translate(624.91 831.76) rotate(180)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff1d0",
    height: 8.11,
    transform: "translate(714.71 117.17) rotate(90)",
    width: 13.57,
    x: 291.98,
    y: 411.88
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff1d0",
    height: 8.11,
    transform: "translate(730.71 133.27) rotate(90)",
    width: 13.57,
    x: 291.93,
    y: 427.93
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 361.73,
    cy: 321.23,
    fill: "#59a545",
    r: 67.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M350.17,354.1a7.47,7.47,0,0,1-5.3-2.19L322.7,329.73a7.5,7.5,0,0,1,10.6-10.61L350.17,336l38.71-38.71a7.5,7.5,0,0,1,10.61,10.6l-44,44A7.51,7.51,0,0,1,350.17,354.1Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 425.77,
    cy: 150.86,
    fill: "#fedc7d",
    r: 16.72,
    style: {
      isolation: "isolate"
    },
    transform: "translate(-18.36 68.46) rotate(-9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 627.79,
    cy: 192.05,
    fill: "#fedc7d",
    r: 22.23,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.15,220.62c10,10.07,29.22,18.58,38.63,21.85-7.9,9.53-3.39,12-5,19-15.13-6.57-44-20.53-38.4-23.74S654.2,229,656.15,220.62Z",
    fill: "#78d0eb",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,254.76c-12.92,2.22-29.55,12.27-37,17.67-3-11-7.27-8.92-11.77-13.87,13-8,38.87-22.42,38.34-16.49S232.53,248.86,237.82,254.76Z",
    fill: "#78d0eb",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.77,75c-16.69,5.66-36.66,22.5-45.44,31.23-6.34-14-11.52-10.31-18.54-15.94,15.59-13.31,46.9-37.94,47.43-29.95S683.5,68.29,691.77,75Z",
    fill: "#9fdbef",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.49,60.06C103.42,61.89,74,76.36,60.61,84.33c-3.47-19-10.92-16.06-17.75-25.07,23-11.48,68.68-32,66.9-22.08S117.44,49.35,125.49,60.06Z",
    fill: "#9fdbef",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.45,187.44C481.17,197,513.57,199.55,529,199.5c-6.64,17.94,1.19,19.19,2.47,30.31-25.43-1.84-74.66-7.4-68.15-14.94S462.89,200.62,461.45,187.44Z",
    fill: "#9fdbef",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.87,183.5l24.8,18.25,22.62-25.41-27.15-20Z",
    fill: "#b3cdde",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,162.3l-38.72-3.54-8.05,42.4,42.43,4Z",
    fill: "#007f9b",
    style: {
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.8,132.15c-9.28-20.09-35.87-45.88-50.45-58.42,18.53-9,36.52-27,43.58-35.44,21,20.1,60.13,60.47,48.49,61.14S285.82,121.52,276.8,132.15Z",
    fill: "#00a3c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.92,75.55c8.32-13.21,13.36-38.85,15.18-52.29,12.43,7.52,30,11.22,37.71,12.16-3.82,20.15-12.67,58.8-17.54,52.17S466.68,76.8,456.92,75.55Z",
    fill: "#00a3c4",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.86,
    cy: 208.45,
    fill: "#fedc7d",
    r: 16.72,
    style: {
      isolation: "isolate"
    },
    transform: "translate(-32.08 9.27) rotate(-9)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalOneLandingImage);
export default __webpack_public_path__ + "static/media/CapitalOneLandingImage.e035e90f51d36510b4998e466dfffd5c.svg";
export { ForwardRef as ReactComponent };